import { PropertyType } from '@rma/generic/domain/types';
import { RmaIcons } from '@rma/generic/ui/icon';

export type PropertyTypes = 'house' | 'apartment' | 'land' | 'unit' | 'singlefam' | 'condo' | 'townhouse';

export const PropertyTypesIcons = {
  apartment: 'apartment',
  condo: 'apartment',
  house: 'cottage',
  land: 'park',
  singlefam: 'cottage',
  townhouse: 'domain',
  unit: 'domain',
} as const satisfies Record<PropertyTypes, RmaIcons>;

export const PropertyTypeMapping = {
  apartment: 'Apartment',
  condo: 'Condo',
  house: 'House',
  land: 'Land',
  singlefam: 'SingleFam',
  townhouse: 'Townhouse',
  unit: 'Unit',
} as const satisfies Record<PropertyTypes, PropertyType>;
